import type Competence from "constants/Competence";
import type {
  CommuneOuCommuneAssocieeDeleguee,
  EnrichedContactMetier,
  Metier,
  Perimetre,
  Poste,
  Territoire,
} from "models";

export interface SearchFilters {
  communesOuCommunesAssocieesDeleguees: Array<CommuneOuCommuneAssocieeDeleguee>;
  competences: Array<Competence>;
  metiers: Array<Metier>;
  perimetres: Array<Perimetre>;
  postes: Array<Poste>;
  isPostesVacants: boolean | undefined;
  territoires: Array<Territoire>;
}

export type SearchFilterFunction<K extends keyof SearchFilters> = (
  contactMetier: EnrichedContactMetier,
  filtersArray: SearchFilters[K]
) => boolean;

export type SearchFilterFunctions = {
  [K in keyof SearchFilters]: SearchFilterFunction<K>;
};

export const emptyFilters: SearchFilters = {
  communesOuCommunesAssocieesDeleguees: [],
  competences: [],
  metiers: [],
  perimetres: [],
  postes: [],
  isPostesVacants: undefined,
  territoires: [],
};
